export const faqs = [
    {
        question: "Is there a fee for using your platform to buy or sell items?",
        answer: ' No. Our platform is free to use for both buyers and sellers. There are no listing fees or commissions charged for selling or buying items.'
    },
    {
        question: "How do I list an item for sale?",
        answer: 'listing an item is simple! Just log in to your account, click on the "Sell" button, and upload pictures of the items you want to sell and provide descriptions. Once your listing is live, potential buyers can find and purchase your item.'
    },
    {
        question: "How can I ensure the quality of items before making a purchase?",
        answer: "The website typically provides detailed item descriptions, photos, and seller ratings to help buyers assess the quality and condition of items before making a purchase. Buyers can also reach out to sellers with any questions or concerns they may have."
    },
    {
        question: "Is there a limit to the number of items I can list for sale?",
        answer: "There is typically no limit to the number of items you can list for sale on"

    }
]